import styled from 'styled-components';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import { Box, Card, Header, Layout, Text } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

const defaultProps = {
  theme: {
    color: {
      surface: {
        container: {
          background: 'transparent'
        },
        layer: {
          background: 'transparent'
        }
      }
    }
  }
};

export const BusinessErrorPageWithBackground = styled.div`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  height: 100%;

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => theme.color.surface.container.background};
  }
`;
BusinessErrorPageWithBackground.defaultProps = defaultProps;

export const BusinessErrorPageLayout = styled(Layout)`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  height: 100%;
  overflow: hidden;

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => theme.color.surface.container.background};
    margin: 0 auto;
    max-width: 900px;
    overflow: unset;
    position: relative;
  }
`;
BusinessErrorPageLayout.defaultProps = defaultProps;

export const BusinessErrorCard = styled(Card)`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  box-shadow: none;
  margin-top: 2.063rem;
  margin-bottom: 2.75rem;
  z-index: 30;

  @media only screen and ${devices.fromxxsmall} {
    width: 19.75rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 34.75rem;
  }
  @media only screen and ${devices.fromsmall} {
    box-shadow: unset;
    width: 35.625rem;
  }
  @media only screen and ${devices.frommedium} {
    border-radius: 0 ${tokens.size.radius.large} ${tokens.size.radius.large} ${tokens.size.radius.large};
  }
`;
BusinessErrorCard.defaultProps = defaultProps;

export const BusinessErrorCardTitle = styled(Header.h3)`
  text-align: center;
  line-height: 2rem;
`;

export const BusinessErrorCardMessage = styled(Text)`
  text-align: center;
`;

export const BackgroundItemsContainer = styled(Box)`
  .ScribbleSVG, .HandCardSVG {
      display: none;
      position: absolute;
      z-index: 10;

      @media only screen and ${devices.fromsmall} {
        display: initial;
      }
    }
    .ScribbleSVG {
      right: 0;
      top: -5%;
    }
    .HandCardSVG {
      left: -6%;
      top: 30%;
    }
`;
